export const es = {
  whatsNew: {
    title: "Novedades",
    intro: "Esto es lo nuevo en Vamos Tamos.",
    teamsTitle: "Guarda tus equipos",
    teamsBody: "Guarda una lista con un nombre y un PIN de 4 dígitos, y recárgala cuando quieras.",
    languagesTitle: "Más idiomas",
    languagesBody: "Vamos Tamos ahora habla 6 idiomas, incluidos alemán e indonesio.",
    cta: "Entendido",
    badge: "Nuevo",
  },
  common: {
    loading: "Cargando...",
    points: "pts",
    court: "Pista",
    team: "Equipo",
    player: "Jugador",
    rank: "Puesto",
    score: "Puntuación",
    share: "Compartir resultados",
    linkCopied: "Enlace copiado al portapapeles",
    shareFailed: "El torneo es demasiado grande para compartir por URL. Intenta con menos jugadores.",
    and: "y",
    close: "Cerrar",
    save: "Guardar",
    cancel: "Cancelar",
    back: "Atrás",
    yes: "Sí, Eliminar",
    no: "No, Volver",
    editable: "Editable",
    buyMeCoffee: "Invítame a un café",
  },
  results: {
    leastGames: "Menos partidos",
    leastGamesTooltip: "Menor número de partidos jugados",
  },
  tournament: {
    new: "¿Americano o Mexicano?",
    create: "Crear torneo",
    nameRequired: "El nombre del torneo es obligatorio",
    tournamentName: "Nombre del torneo",
    round: "Ronda",
    completeRound: "Completar ronda",
    completingRound: "Completando...",
    nextRoundReady: "La ronda #{round} está lista",
    endTournament: "Terminar torneo",
    formatRequired: "Elige Americano o Mexicano",
    enterScores: "Introduce todos los marcadores antes de continuar",
    bench: "Jugadores en banquillo",
    finalResults: "torneo",
    finished: "Torneo Finalizado",
    winner: "Ganador",
    winners: "Ganadores",
    with: "con",
    points: "puntos",
    summary: "Torneo completado en {rounds} rondas con {players} jugadores en {courts} pistas",
    confirmEnd: "¿Seguro? Los puntos de esta ronda no se incluirán en el total",
    yes: "Sí",
    no: "No",
    newTournament: "Comenzar nuevo torneo",
    playedMatches: "Jugado",
    pairingComplete: "Emparejamientos listos",
    allPlayersPaired: "¡Torneo completado!",
    roundSaved: "Ronda #{round} guardada",
    continueWithNewPairs: "Continuar torneo",
    viewResults: "Ver resultados",
    tournamentEnded: "Torneo finalizado",
    roundSettings: "Ajustes de ronda",
    pointsModeLabel: "A puntos hasta {points}",
    timeModeLabel: "Por tiempo, {minutes} min",
    timer: "Temporizador: {time}",
    timerStatus: "Temporizador de la ronda",
    timeUp: "¡Tiempo agotado! Termina la ronda e introduce los marcadores.",
    editRoster: "Editar Jugadores",
    editRosterTitle: "Editar Jugadores y Pistas",
    addPlayer: "Añadir Jugador",
    removePlayer: "Quitar",
    reactivatePlayer: "Reactivar",
    inactivePlayers: "Jugadores Inactivos",
    applyChanges: "Aplicar Cambios",
    rosterWarning: "La ronda actual se regenerará y los marcadores se reiniciarán",
    rosterWarningTitle: "Aplicar los cambios reiniciará esta ronda",
    rosterWarningRegenerate: "Los equipos de la ronda actual se barajarán y regenerarán.",
    rosterWarningScores: "Los marcadores ya introducidos en esta ronda se borrarán.",
    rosterWarningNewPlayers: "Los nuevos jugadores entran de inmediato y se añaden a esta ronda.",
    rosterWarningSafe: "Los marcadores de rondas anteriores ya completadas se conservan.",
    minPlayersWarning: "Se necesitan al menos 4 jugadores activos",
    courtsReduced: "Pistas reducidas a {courts} (no hay suficientes jugadores activos)",
    playerInactive: "Inactivo",
    mixedPairsWarning: "Las parejas mixtas requieren igual número de hombres y mujeres",
    arrangeFirstRound: "Configurar primera ronda",
    arrangeFirstRoundTitle: "Configurar primera ronda",
    arrangeFirstRoundHelp: "Toca o haz clic en una tarjeta de jugador y luego en otro hueco para intercambiarlos. Usa la fila del banquillo para meter o sacar jugadores. Funciona igual en móvil y escritorio.",
    resetFirstRound: "Restablecer cambios",
    firstRoundUpdated: "Primera ronda actualizada",
    manualFirstRoundInvalid: "Cada jugador activo debe aparecer exactamente una vez en la configuración de la primera ronda.",
    manualFirstRoundMixedPairs: "Las parejas mixtas requieren un hombre y una mujer en cada equipo.",
    manualFirstRoundBenchSlot: "Banquillo {number}",
    removePlayerTitle: "Quitar Jugador",
    removePlayerMessage: "¿Cómo quieres quitar a {player}?",
    removePlayerExplanation: "Inactivar: El jugador permanece en la clasificación pero no se le asignarán partidos. Eliminar Completamente: El jugador se borra del torneo por completo.",
    makeInactive: "Inactivar (mantener en clasificación)",
    removeCompletely: "Eliminar Completamente (borrar del torneo)",
    removePlayerFinalTitle: "¿Estás seguro?",
    removePlayerFinalMessage: "Esto eliminará permanentemente a {player} y todos sus puntos del torneo. Esta acción no se puede deshacer."
  },
  tvMode: {
    subtitle: "Muestra esta página en una TV para ver ranking y pistas en vivo",
    round: "Ronda {round}",
    leaderboard: "Clasificación",
    lastRound: "Última ronda",
    onCourt: "En pista ahora",
    noGames: "Sin partidos activos todavía",
    bench: "Esperando esta ronda",
    missingStateTitle: "El modo TV necesita un enlace de torneo",
    missingStateBody: "Abre el modo TV desde un torneo activo o finalizado para reflejar los datos en pantalla.",
    openButton: "Abrir modo TV",
  },
  theme: {
    switchToDark: 'Cambiar a modo oscuro',
    switchToLight: 'Cambiar a modo claro',
    toggleLabel: 'Alternar modo de color',
  },
  playerSetup: {
    title: "¿Quién juega?",
    addPlayer: "Añadir jugador",
    playerName: "Jugador",
    playerRequired: "El nombre es obligatorio",
    formatTitle: "Estilo de torneo",
    formatAmericano: "Juego Americano",
    formatMexicano: "Juego Mexicano",
    courtsTitle: "Número de pistas",
    court: "Pista",
    courts: "Pistas",
    startTournament: "Iniciar torneo",
    loadTeam: "Cargar equipo",
    saveTeam: "Guardar equipo",
    loadTeamTitle: "Cargar un equipo guardado",
    saveTeamTitle: "Guardar este equipo",
    teamCode: "Nombre del equipo",
    loadTeamHint: "Introduce un nombre de equipo fácil de recordar para reutilizar su lista de jugadores.",
    saveTeamHint: "Dale a esta lista de jugadores un nombre fácil de recordar para reutilizarla la próxima vez.",
    savedTeamsTitle: "Tus equipos guardados",
    noSavedTeams: "Aún no hay equipos guardados en este dispositivo.",
    teamNameRequired: "Introduce un nombre de equipo",
    noPlayersToSave: "Añade al menos un jugador antes de guardar",
    teamNotFound: "No se encontró ningún equipo con ese nombre",
    teamSaved: "Equipo guardado",
    teamSaveFailed: "No se pudo guardar el equipo. Inténtalo de nuevo.",
    teamSavedLocally: "Equipo guardado en este dispositivo. Aún no se ha confirmado que esté disponible para compartir.",
    teamLoaded: "Equipo cargado",
    updatingTeam: "Al guardar se actualizará tu equipo \"{name}\".",
    teamNameTaken: "Ese nombre ya está en uso. Toca la sugerencia o escribe otro.",
    suggestionLabel: "Nombre sugerido",
    load: "Cargar",
    createTeam: "Crear equipo",
    pinFourDigits: "PIN (4 dígitos)",
    pinEnterPrompt: "Introduce el PIN de 4 dígitos del equipo.",
    pinCreateWarning: "Necesitarás este PIN para cargar el equipo más tarde. No se puede recuperar \u2014 si lo olvidas, tendrás que crear un equipo nuevo.",
    pinInvalid: "El PIN debe tener 4 dígitos.",
    pinIncorrect: "PIN incorrecto. Los PIN no se pueden recuperar \u2014 crea un equipo nuevo si lo olvidaste.",
    notEnoughPlayers: "Necesitas al menos {count} jugadores para {courts} pistas",
    duplicateName: "Nombre duplicado",
    roundTypeTitle: "Tipo de ronda",
    roundTypePoints: "Puntos",
    roundTypeTime: "Basado en tiempo",
    targetPoints: "Puntos a jugar",
    roundMinutes: "Minutos por ronda",
    timerHint: "Sonará un silbato y aparecerá un aviso cuando el tiempo llegue a 0.",
    mixedPairsLabel: "Parejas mixtas (H+M)",
    mexicanoPairingTitle: "Emparejamiento Mexicano",
    mexicanoPairingHint: "Elige cómo se reparten en equipos los 4 jugadores de cada pista.",
    mexicanoPairingStandard: "Opción 1: #1 + #3 vs #2 + #4",
    mexicanoPairingStandardDescription: "Une al jugador mejor clasificado con el tercero, y al segundo con el cuarto en cada pista.",
    mexicanoPairingAlternate: "Opción 2: #1 + #4 vs #2 + #3",
    mexicanoPairingAlternateDescription: "Une al mejor jugador con el cuarto, y a los dos del medio entre sí en cada pista.",
    gender: "Género",
    male: "Hombre",
    female: "Mujer",
    genderBalance: "Las parejas mixtas requieren el mismo número de hombres y mujeres."
  },
  rules: {
    titleAmericano: "Cómo funciona el Americano",
    titleMexicano: "Cómo funciona el Mexicano",
    teamSetupTitle: "Formación de equipos",
    teamSetupAmericano: "Los jugadores se asignan aleatoriamente antes de cada ronda para variar compañeros y rivales.",
    teamPattern13v24: "#1+#3 juegan contra #2+#4",
    teamPattern14v23: "#1+#4 juegan contra #2+#3",
    teamSetupMexicano: "Los emparejamientos siguen la clasificación en vivo. Los jugadores se agrupan de 4 en 4 por rango (top 4, siguientes 4, etc.). En cada pista: {pattern}. La siguiente pista sigue el mismo patrón. Así los fuertes se enfrentan a fuertes y los más débiles entre sí: el objetivo es la puntuación individual, no una pareja ganadora única.",
    scoringSystemTitle: "Sistema de puntuación",
    scoringSystem: "Cada ronda se juega a un número determinado de puntos o por tiempo. Los puntos son individuales: si un equipo gana 13–8, cada jugador ganador recibe 13 y cada perdedor 8.",
    winnerTitle: "Ganador",
    winner: "El jugador con más puntos totales gana y recibe los aplausos. :)",
    faqTitle: "Preguntas frecuentes",
    faqFormatsQ: "¿Cuál es la diferencia entre Americano y Mexicano?",
    faqFormatsA: "En Americano, los jugadores se emparejan al azar en cada ronda, así que todos juegan con y contra todos. En Mexicano, los emparejamientos siguen la clasificación en vivo, juntando a jugadores de nivel similar.",
    faqSportsQ: "¿Puedo usarlo para deportes que no sean pádel?",
    faqSportsA: "Sí. Aunque está hecho para pádel, los formatos Americano y Mexicano sirven para pickleball, tenis, tenis de mesa, bádminton y cualquier juego que se puntúe por puntos.",
    faqFreeQ: "¿Es gratis y necesito una cuenta?",
    faqFreeA: "Es totalmente gratis y sin registro. Los torneos funcionan en tu navegador e incluso sin conexión.",
    faqPlayersQ: "¿Cuántos jugadores y pistas puedo usar?",
    faqPlayersA: "Cualquier número de jugadores en una o varias pistas. La app rota a los jugadores automáticamente en cada ronda."
  },
  privacy: {
    title: "Política de Privacidad",
    lastUpdated: "Última actualización",
    dataCollection: "Recopilación de Datos",
    dataCollectionText: "Vamos Tamos no recopila ni almacena datos personales. Todos los datos del torneo permanecen en tu dispositivo.",
    localStorage: "Almacenamiento Local",
    localStorageText: "Los datos del torneo se almacenan localmente en el localStorage de tu navegador para mantener el estado del juego. Puedes borrar estos datos en cualquier momento desde la configuración de tu navegador.",
    cookies: "Cookies",
    cookiesText: "Esta aplicación no utiliza cookies de seguimiento. Solo se usa el almacenamiento esencial del navegador (localStorage) para la funcionalidad del torneo.",
    thirdParty: "Servicios de Terceros",
    thirdPartyText: "Usamos Vercel Web Analytics para recopilar datos de uso anónimos y agregados (vistas de página, conteo de visitantes). Estos datos están enfocados en la privacidad y no rastrean usuarios individuales, no usan cookies ni recopilan información personal. Más información en vercel.com/analytics.",
    rights: "Tus Derechos (GDPR/CCPA)",
    rightsText: "Como no se recopilan ni procesan datos personales, mantienes el control total de tus datos. Puedes eliminar todos los datos del torneo almacenados localmente borrando el localStorage de tu navegador.",
    contact: "Contacto",
    contactText: "Para preguntas sobre privacidad, contacta: the.adnan@gmail.com",
    backHome: "Volver a Inicio"
  }
};
